"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplexerSocketArtifactId = exports.wsVs = exports.userChannel = exports.wsClient = exports.WixArtifactIdHeader = void 0;
exports.WixArtifactIdHeader = 'x-wix-artifact-id';
exports.wsClient = 'ws.manager';
exports.userChannel = '@user-inbox';
exports.wsVs = 'ws.vs';
exports.DuplexerSocketArtifactId = 'com.wixpress.infra.wix-duplexer-sockets-server';
//# sourceMappingURL=constants.js.map